/**
* @author wangjunfeng
*/

<template>
  <div
    class="sy-container__aside font-color-primary background-color-sidebar"
  >
    <h3
      :class="['sy-aside__title-wrap font-color-primary', { 'bottom-line': !collapse }]"
    >
      <span
        class="title"
        v-show="!collapse"
      >{{sideTitle ? sideTitle : pageText.myMall}}</span>
      <span class="search-icon"></span>
    </h3>
    <el-menu
      class="sy-aside__menu"
      router
      :collapse="collapse"
      :default-openeds="defaultDpeneds"
      :default-active="routerPath"
      data-spm-d="d121"
    >
      <template v-for="(menu, menuIndex) in menuList">
        <el-submenu
          :key="menu"
          :index="`${menu[menuProps.submenuName]}}${menuIndex}`"
          :class="{'sy-aside__menu-collapse': collapse}"
        >
          <template slot="title">
            <div class="sy-aside__icon-wrap">
              <i class="iconfont sy-side__icon" v-html="menu[menuProps.menuItemIcon]"></i>
            </div>
            <span v-show="!collapse">{{ menu[menuProps.submenuName] }}</span>
          </template>
          <template v-for="(item, index) in menu[menuProps.menuList]">
            <li
              :key="item"
              v-if="index === 0 && menu[menuProps.menuList].length > 1 && collapse"
              class="collapse-title"
            >{{ menu[menuProps.submenuName] }}</li>
            <el-menu-item
              :key="item"
              class="aside-menu-item collapse-menu__item"
              :style="{ 'padding-left': collapse ? '24px' : '42px'}"
              :route="item[menuProps.menuItemUrl]"
              :index="item[menuProps.menuItemUrl]"
            >{{ item[menuProps.menuItemName] }}</el-menu-item>
          </template>
        </el-submenu>
      </template>
    </el-menu>
    <div class="sy-aside__footer">
      <i class="iconfont" @click="collapseChangeHandle" v-html="collapse ? '&#xe75c;' : '&#xe75d;'"></i>
    </div>
  </div>
</template>

<script>
const ASIDE_MENU_COLLAPSE_KEY = 'ASIDE_MENU_COLLAPSE_KEY' // 本地存储展开/收起标识key
export default {
  name: 'sy-aside',
  props: {
    pageText: {
      type: Array,
      default: () => []
    },
    menuList: {
      type: Array,
      default: () => ([])
    },
    menuProps: {
      type: Object,
      default: () => {
        return {
          submenuName: 'name', // 一级菜单名
          menuList: 'appMenuList',  // 二级菜单list
          menuItemName: 'applicationName', // 菜单项名称
          menuItemUrl: 'url', // 菜单项跳转地址
          menuItemIcon: 'iconUrl' // 菜单icon
        }
      }
    },
    collapse: {
      type: Boolean,
      default: false
    },
    // 侧边栏标题
    sideTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    defaultDpeneds () {
      return this.menuList.map((i, index) => {
        return `${i[this.menuProps.submenuName]}}${index}`
      })
    },
    routerPath () {
      let arr = this.$route.path.split('')
      // const menuCode = this.$route.query['menuCode'] || this.$route.meta['menuCode']
      // 适配路由末尾带/而无法展开菜单
      // return menuCode || (arr[arr.length - 1] === '/' ? arr.slice(0, arr.length - 1).join('') : this.$route.path)
      return arr[arr.length - 1] === '/' ? arr.slice(0, arr.length - 1).join('') : this.$route.path
    }
  },
  mounted () {
    this.getSessionKey()
  },
  methods: {
    // aside展开收起标识
    collapseChangeHandle () {
      this.collapse = !this.collapse
      this.$emit('collapse:update', this.collapse)
      window.sessionStorage.setItem(ASIDE_MENU_COLLAPSE_KEY, `${this.collapse}`)
    },
    getSessionKey () {
      const collapse = window.sessionStorage.getItem(ASIDE_MENU_COLLAPSE_KEY)
      this.collapse = collapse === 'true'
      this.$emit('collapse:update', this.collapse)
    }
  }
}
</script>

<style scoped lang="scss">
.sy-container__aside {
  max-width: 170px;
  position: relative;
  overflow: hidden;
  //min-height: 100vh;
  background-color: currentColor;
  z-index: 1010;
  //transition: width .3s cubic-bezier(0.23, 1, 0.32, 1);
  //::v-deep .el-menu--collapse {
  //  width: 56px;
  //}
  .sy-aside__title-wrap {
    //background-color: currentColor;
    //background-color: #3072F3;
    &.bottom-line {
      position: relative;
      &:after {
        content: '';
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 10px;
        right: 10px;
        background-color: rgba(255, 255, 255, .2);
      }
    }
    .title {
      height: 54px;
      line-height: 54px;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      display: inline-block;
      padding-left: 20px;
      //transition: display 300ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    .search-icon {
      height: 40px;
      line-height: 40px;
      padding: 0 16px;
      width: 20px;
    }
  }
  ::v-deep .el-menu {
    border-right: none;
  }
  .sy-aside__menu {
    background-color: transparent;
    font-size: 12px;
    height: calc(100% - 94px);
    margin-bottom: 41px;
    overflow-y: auto;
    box-sizing: border-box;
    width: 170px;
    //padding-top: 54px;
    //padding-bottom: 40px;
    //transition: width 1s;

    //&:not(.el-menu--collapse) {
    //  width: 100%;
    //}
    ::v-deep div.el-submenu__title:hover,
    ::v-deep li.el-menu-item:focus,
    ::v-deep li.el-menu-item:hover {
       background-color: rgba(255, 255, 255, .15);
    }
    li.el-menu-item.is-active {
      background-color: rgba(255, 255, 255, .15);
      &:before {
        content: '';
        display: block;
        width: 3px;
        background-color: rgba(255, 255, 255, .8);
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
      }
    }
    ::v-deep .el-menu {
      background-color: transparent;
    }
    &.el-menu--collapse {
      width: 56px;
      ::v-deep div.el-submenu__title:hover,
      ::v-deep li.el-menu-item:focus,
      ::v-deep li.el-menu-item:hover {
        background-color: transparent;
      }
      .sy-aside__icon-wrap:hover {
        background-color: rgba(255, 255, 255, .15);
      }
    }
    ::v-deep .el-submenu__title {
      padding:0 17px !important;
    }
    ::v-deep .el-submenu__title,
    .aside-menu-item {
      color: rgba(255, 255, 255, .9);
      transform: none;
     /* &:hover {
        color: #F4FAFF;
      }*/
    }
    ::v-deep .el-submenu.is-active {
      &.sy-aside__menu-collapse .sy-aside__icon-wrap {
        background-color: rgba(255, 255, 255, .15);
      }
      .sy-side__icon {
        color: #fff;
      }
      .el-submenu__title {
        color: #fff;
        .el-submenu__icon-arrow {
          color: #fff;
        }
      }
    }
    ::v-deep .el-submenu__title {
      height: 40px;
      line-height: 40px;
      font-weight: 500;
      .el-submenu__icon-arrow {
        //display: none;
        margin-top: -6px;
        color: rgba(255, 255, 255, .7);
        font-size: 14px;
        font-weight: bold;
      }
    }
    .aside-menu-item {
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      width: 100%;
      min-width: 100%;
    }
    .sy-side__icon {
      color: rgba(255, 255, 255, .7);
      font-size: 20px;
    }
    .sy-aside__icon-wrap {
      display: inline-block;
      line-height: 1;
    }
    /* 收起后submenu-title样式 */
    .sy-aside__menu-collapse {
      ::v-deep .el-submenu__title {
        padding:0 9px !important;
      }
      .sy-aside__icon-wrap {
        //width: 38px;
        padding: 0 9px;
        height: 32px;
        border-radius: 4px;
        line-height: 32px;
        overflow: hidden;
      }
    }
  }
  .sy-aside__footer {
    padding-left: 16px;
    border-top: 1px solid rgba(255, 255, 255, .2);
    line-height: 40px;
    height: 40px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    i {
      font-size: 16px;
      color: #fff;
      cursor: pointer;
    }
  }
  .el-opacity-transition,
  .horizontal-collapse-transition{
    transition: none;
  }
}
</style>

<style lang="scss">
  .el-menu--vertical {
    .collapse-title {
      padding-left: 16px;
      padding-top: 5px;
      padding-bottom: 8px;
      font-size: 14px;
      font-weight: 500;
    }
    .collapse-menu__item {
      height: 32px;
      line-height: 16px;
      font-size: 12px;
      color: #2E3656;
      padding: 8px;
    }
  }
</style>
